const baseStyleOverlay = {
  bg: 'rgba(22, 22, 22, 0.7)',
  backdropFilter: 'blur(1px)',
  zIndex: 'modal',
};

const baseStyleDialog = (props) => {
  const { scrollBehavior } = props;

  return {
    borderRadius: '16px',
    color: 'inherit',
    my: '3.75rem',
    zIndex: 'modal',
    maxH: scrollBehavior === 'inside' ? 'calc(100% - 7.5rem)' : undefined,
    boxShadow: '0px 4px 12px 6px rgba(46, 47, 48, 0.06)',
    border: '1px solid #DDDEDE',
  };
};

const baseStyleCloseButton = {
  position: 'absolute',
  top: '12px',
  right: '12px',
  insetEnd: 3,
  bg: '#F3F4F9',
  borderRadius: '8px',
  _focus: { outline: 'none' },
  _active: { bg: 'none !important' },
  svg: { bg: '#F3F4F9', width: '10px', height: '10px', color: '#6D659D' },
};

const baseStyle = (props) => ({
  overlay: baseStyleOverlay,
  dialog: baseStyleDialog(props),
  closeButton: baseStyleCloseButton,
});

export const Modal = {
  baseStyle,
};
